import React, {Component} from "react";
import {AgencyHeader} from "./AgencyHeader";
import {AgencyTabs} from "./AgencyTabs";
import AgencyInfo from "./AgencyInfo";
// `AgencyMemoryAutonomySection` (el DEFAULT de agencia de «¿Cuánto aprueba Dashbo solo?») quedó
// OCULTA el 08/09 — card 8uu3IdNd, que cambia la decisión del 07/09. El knob pasa a ser por
// cliente y punto: dos niveles para una preferencia que todavía nadie pidió configurar en bloque
// eran un control de más. El componente, su hook (`useAgencyMemoryAutonomy`), su endpoint
// (`agent/memory-autonomy/`, sólo admins) y el campo `Agency._memory_autonomy` siguen VIVOS y en
// uso: el default de la agencia es el que hereda un cliente que nunca movió su riel. Volver a
// ofrecerlo es descomentar estas dos líneas.
// import {AgencyMemoryAutonomySection} from "./AgencyMemoryAutonomySection";

export class AgencyProfileContent extends Component {
    constructor(props) {
        super(props);
        this.state = {
        };
    }

    render() {
        return (
            <section className="section-content">
                <AgencyHeader/>
                <AgencyTabs activeTab="-fifth"/>
                <div className="section-body h-items">
                    <AgencyInfo/>
                    {/* <AgencyMemoryAutonomySection/> — ver el comentario del import. */}
                </div>
            </section>
        )
    }
}
